// Shared between the /voice client UI and the server TTS lib — keep this
// module dependency-free so it's safe in the client bundle.

// User-selectable Eleven v4 audio tags. These are inline text directives the
// model interprets: no extra cost, no separate endpoint. Each one is named in
// the v4 tag lists at elevenlabs.io/docs/eleven-creative/playground/text-to-speech
// and elevenlabs.io/docs/overview/capabilities/text-to-speech/best-practices
// ([sings] is listed there as experimental, so it is not offered). Delivery
// still varies by voice.
export const VOICE_MOODS = [
  'excited',
  'whispers',
  'laughs',
  'sarcastic',
  'sighs',
  'shouts',
  'curious',
  'crying',
] as const

export type VoiceMood = typeof VOICE_MOODS[number]

export function isValidVoiceMood(value: unknown): value is VoiceMood {
  return typeof value === 'string' && (VOICE_MOODS as readonly string[]).includes(value)
}

// Tags the v4 docs name as voice or delivery directions
// (elevenlabs.io/docs/overview/capabilities/text-to-speech/best-practices).
// Only these are treated as direction rather than speech when a line is
// measured and validated. Sound-effect tags ([gunshot], [applause]) and the
// experimental ones ([sings], [strong X accent]) are left out on purpose, and
// so is any other bracketed text: it counts as spoken characters.
export const AUDIO_TAGS: readonly string[] = [
  ...VOICE_MOODS,
  'laughs harder',
  'starts laughing',
  'wheezing',
  'exhales',
  'snorts',
  'mischievously',
  'clears throat',
]

const AUDIO_TAG_SET = new Set(AUDIO_TAGS)

export function isAudioTag(inner: string): boolean {
  return AUDIO_TAG_SET.has(inner.trim().toLowerCase())
}
